import React from 'react';
import { Paper, Box, Typography, Card, CardContent, Chip } from '@mui/material';
import { Warning } from '@mui/icons-material';
import dayjs from 'dayjs';
import 'dayjs/locale/it';

dayjs.locale('it');

const UserDetailsMemberships = ({ memberships }) => {
  const getMembershipStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'success';
      case 'expired':
        return 'warning';
      case 'pending':
        return 'info';
      default:
        return 'default';
    }
  };

  const getMembershipStatusLabel = (status) => {
    switch (status) {
      case 'active':
        return 'Attiva';
      case 'expired':
        return 'Scaduta';
      case 'pending':
        return 'In attesa';
      default:
        return status;
    }
  };

  const getPaymentTypeLabel = (type) => {
    switch (type) {
      case 'cash':
        return 'Contanti';
      case 'stripe':
        return 'Stripe';
      case 'paypal':
        return 'PayPal';
      case 'bank_transfer':
        return 'Bonifico Bancario';
      default:
        return type;
    }
  };

  const formatCurrency = (amount) => {
    return `€${amount?.toFixed(2) || '0.00'}`;
  };

  const isExpired = (endDate) => {
    return endDate && dayjs(endDate).isBefore(dayjs(), 'day');
  };

  if (!memberships || memberships.length === 0) {
    return (
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Tesseramenti
        </Typography>
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Nessun tesseramento trovato
          </Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Tesseramenti
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {memberships.map((membership) => {
          const expired = isExpired(membership.endDate);

          return (
            <Card key={membership._id} variant="outlined">
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                  <Box>
                    <Typography variant="h6" gutterBottom>
                      {membership.membershipId || 'N/A'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Tipo Pagamento: {getPaymentTypeLabel(membership.paymentType)}
                    </Typography>
                  </Box>
                  {expired && <Chip icon={<Warning />} label="Scaduto" color="warning" size="small" />}
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary">
                      Data Inizio:
                    </Typography>
                    <Typography variant="body2">
                      {membership.startDate ? dayjs(membership.startDate).format('DD-MMM-YY') : 'N/A'}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary">
                      Data Fine:
                    </Typography>
                    <Typography variant="body2">
                      {membership.endDate ? dayjs(membership.endDate).format('DD-MMM-YY') : 'N/A'}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2" color="text.secondary">
                      Importo:
                    </Typography>
                    <Typography variant="body2">
                      {formatCurrency(membership.amount)}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 2 }}>
                  <Chip
                    label={`Stato: ${getMembershipStatusLabel(membership.status)}`}
                    size="small"
                    color={getMembershipStatusColor(membership.status)}
                  />
                  {/* {membership.currency && (
                    <Chip
                      label={`Valuta: ${membership.currency}`}
                      size="small"
                      variant="outlined"
                    />
                  )} */}
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Paper>
  );
};

export default UserDetailsMemberships;

